import {useMsal} from '@azure/msal-react'
import {loginRequest} from '../../Auth/auth-config'
import HealthPrismLogo from '../../icons/HealthPrism.png'
import PeoplePrism from '../../icons/PeoplePrism.svg'
import deloitteLogoBlack from '../../icons/deloitte-logo-black.svg'
import Button from '@mui/material/Button'
import {Root, classes} from './SignInPageStyle'
import {useCustomDashboardViewProvider} from '../../store/hooks/customDashboardView'

const SignInPageComponent = () => {
  const {instance} = useMsal()
  const {prismProgram} = useCustomDashboardViewProvider()

  const openInNewTab = (url) => {
    globalThis.open(url, '_blank', 'noopener,noreferrer')
  }

  const handleKeyDown = (e, callback) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault()
      callback()
    }
  }
  return (
    <Root>
      <div className={classes.hpLogo}>
        {prismProgram === 'PeoplePrism' ? (
          <img src={PeoplePrism} width='50%' height='auto' alt='PeoplePrism Logo' />
        ) : (
          <img src={HealthPrismLogo} width='50%' height='auto' alt='HealthPrism Logo' />
        )}
      </div>
      <div className={classes.loginBtn}>
        <Button
          data-testid='login-button'
          variant='contained'
          className={classes.loginBtnComponent}
          onClick={() => instance.loginRedirect(loginRequest)}
        >
          Login
        </Button>
      </div>
      <div
        style={{
          backgroundColor: '#F2F2F2',
          height: '65px',
          bottom: '0px',
          position: 'absolute',
          width: '100%',
          textAlign: 'center',
          display: 'flex'
        }}
      >
        <div aria-hidden='true' className={classes.cookiesContainer}>
          <Button
            target='_href'
            rel='noopener noreferrer'
            onClick={() => openInNewTab('https://cookienotice.deloitte.com')}
            onKeyDown={(e) => handleKeyDown(e, () => openInNewTab('https://cookienotice.deloitte.com'))}
            tabIndex={0}
            className={classes.cookiesBtn}
          >
            Cookies
          </Button>
          <Button
            onClick={() => globalThis.OneTrust?.ToggleInfoDisplay()}
            onKeyDown={(e) => handleKeyDown(e, () => globalThis.OneTrust?.ToggleInfoDisplay())}
            className={`${classes.cookieSettingsBtn} ${classes.cookiesBtn}`}
            tabIndex={0}
          >
            Cookie Settings
          </Button>
        </div>

        <span className={classes.deloitteLogo}>
          <img src={deloitteLogoBlack} width='100px' height='65px' alt='Deloitte Logo' />
        </span>
      </div>
    </Root>
  )
}

export default SignInPageComponent
